var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "repairability" },
    [
      _c("div", { staticClass: "picto" }, [
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _c("img", {
            staticClass: "align-self-center my-1",
            attrs: { alt: "", src: _vm.picto.src, srcset: _vm.picto.srcSet },
          }),
          _vm._v(" "),
          _c("strong", {
            staticClass: "note",
            domProps: { innerHTML: _vm._s(_vm.noteFormated(_vm.note)) },
          }),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "ps-1",
              attrs: {
                href: "#modal-repairability",
                "data-bs-toggle": "modal",
                "aria-label":
                  _vm.label + " " + _vm.noteFormated(_vm.note) + " sur 10",
              },
            },
            [_c("strong", { domProps: { innerHTML: _vm._s(_vm.label) } })]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "ob1-popin-modal2",
        {
          attrs: {
            id: "modal-repairability",
            "aria-labelledby": "modal-label-repairability",
          },
        },
        [
          _c("p", {
            staticClass: "h4",
            attrs: { id: "modal-label-repairability" },
            domProps: { innerHTML: _vm._s(_vm.titlePopin) },
          }),
          _vm._v(" "),
          _c("p", { domProps: { innerHTML: _vm._s(_vm.textPopin) } }),
          _vm._v(" "),
          _vm.urlDocument
            ? _c("ob1-liens", {
                attrs: {
                  "with-arrow": true,
                  text: _vm.linkDocument,
                  href: _vm.urlDocument,
                  target: "_blank",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }